import { render, staticRenderFns } from "./GraphDetail77.vue?vue&type=template&id=8c98f678&scoped=true"
import script from "./GraphDetail77.vue?vue&type=script&lang=js"
export * from "./GraphDetail77.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c98f678",
  null
  
)

export default component.exports